import useLocales from "src/hooks/useLocales";

import ThemeBtn from "../Products/Common/ThemeBtn";
import DErrorResult from "./components/DErrorResult";

const AuthNotValid = () => {
	const { translate } = useLocales();
	return (
		<>
			<DErrorResult errorMessage={translate("dynamic_form.expired_session")} />
			<ThemeBtn
				title='Reiniciar flujo'
				onClick={() => window.location.reload()}
				size='large'
				variant='contained'
				sx={{ mt: 22 }}
			/>
		</>
	);
};

export default AuthNotValid;
